var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmosphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NEON Data Theme - Atmosphere") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -204.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 204.4,
    width: 100,
    height: 100,
    fill: "#00a2af",
    strokeWidth: 1.3401
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.857 214.68a29.857 29.857 0 0 0-29.857 29.857 29.857 29.857 0 0 0 29.857 29.857 29.857 29.857 0 0 0 29.857-29.857 29.857 29.857 0 0 0-29.857-29.857zm0 0.71429a29.143 29.143 0 0 1 29.143 29.143 29.143 29.143 0 0 1-29.143 29.143 29.143 29.143 0 0 1-29.143-29.143 29.143 29.143 0 0 1 29.143-29.143z",
    strokeWidth: 0.41386
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.857,
    cy: 244.54,
    r: 21,
    strokeWidth: 0.29109
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.714 219.25a25.429 25.429 0 0 0-25.429 25.429 25.429 25.429 0 0 0 25.429 25.429 25.429 25.429 0 0 0 25.429-25.429 25.429 25.429 0 0 0-25.429-25.429zm0 1.7143a23.714 23.714 0 0 1 23.714 23.714 23.714 23.714 0 0 1-23.714 23.714 23.714 23.714 0 0 1-23.714-23.714 23.714 23.714 0 0 1 23.714-23.714z",
    strokeWidth: 0.35248
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.571 284.4 0.24442 5.6138-4.7405-3.0184-0.71429 1.2377 4.9844 2.5954-4.9844 2.5954 0.71429 1.2377 4.7405-3.019-0.24442 5.6144h1.4286l-0.24442-5.6144 4.7405 3.019 0.71429-1.2377-4.9838-2.5954 4.9838-2.5954-0.71429-1.2377-4.7405 3.0184 0.24442-5.6138z",
    strokeWidth: 0.33963
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45.729 243.79c-6.0654 0-11.336 3.3974-14.016 8.3923a11.93 11.93 0 0 0-5.3616-1.2874 11.93 11.93 0 0 0-11.93 11.93 11.93 11.93 0 0 0 2.9855 7.8722c-0.07799 0.0266-0.1686 0.0526-0.23382 0.0798-3.4634 1.4431-2.5251 4.4018-2.5251 4.4018h79.73s0.14425-2.3814-0.93806-3.2472c-1.0158-0.81265-2.6074-2.5782-18.727-3.0307a8.8997 8.8997 0 0 0 0.6702-3.3772 8.8997 8.8997 0 0 0-8.9001-8.9001 8.8997 8.8997 0 0 0-4.9319 1.4994c-0.78695-8.0452-7.5695-14.333-15.821-14.333z",
    fill: "#00535c",
    strokeWidth: 0.31214
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.548 257.08c-4.2575 0-7.9569 2.3848-9.8385 5.8908a8.3742 8.3742 0 0 0-3.7635-0.90367 8.3742 8.3742 0 0 0-8.3743 8.3739 8.3742 8.3742 0 0 0 2.0956 5.5258c-0.05475 0.0187-0.11835 0.0369-0.16412 0.056-2.4311 1.013-1.7725 3.0898-1.7725 3.0898h55.965s0.10126-1.6716-0.65846-2.2793c-0.71305-0.57044-1.8302-1.8097-13.145-2.1274a6.247 6.247 0 0 0 0.47044-2.3706 6.247 6.247 0 0 0-6.2473-6.2473 6.247 6.247 0 0 0-3.4619 1.0525c-0.55239-5.6472-5.3133-10.061-11.106-10.061z",
    fill: "#00636a",
    strokeWidth: 0.21911
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.501 284.88c5e-6 3.2495-2.6343 5.8838-5.8838 5.8838s-5.8838-2.6343-5.8838-5.8838c3e-6 -3.2495 5.8838-11.649 5.8838-11.649s5.8838 8.3996 5.8838 11.649z",
    fill: "#fff",
    strokeWidth: 0.081557
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmosphere);
export default __webpack_public_path__ + "static/media/atmosphere.bb2be3c7b51238b79d39dce4f8ad1575.svg";
export { ForwardRef as ReactComponent };